import { STATE } from 'app/constants';

export const area = STATE.translatedComponents;
export const textSet = 3;
